// 401 EMPLOYEE_SESSION_EXPIRED con un token que ya no es el vigente.
//
// Al recargar el TPV, la sesión del empleado se renueva en silencio
// (employeePinAuth/refresh), y el servidor revoca el token anterior de ese
// dispositivo. Las peticiones que ya iban con el token viejo vuelven con
// 401 EMPLOYEE_SESSION_EXPIRED: no es que la sesión haya muerto, es que se
// ha rotado. En ese caso se reintenta UNA vez con el token vigente en vez de
// borrar la sesión (que borraría el token nuevo y dejaría al empleado fuera).

const HEADER = "X-Employee-Session";

function headerOf(config) {
  const h = config?.headers || {};
  return h[HEADER] || h[HEADER.toLowerCase()] || null;
}

/**
 * Devuelve la config para reintentar con el token vigente, o null si el
 * 401 es de verdad (mismo token, ya reintentada, o sin token vigente).
 */
export function rotatedEmployeeSessionRetryConfig(error, storage = window.localStorage) {
  const config = error?.config;
  if (!config || config.__employeeSessionRetried) return null;
  const sent = headerOf(config);
  let current = null;
  let expiresAt = null;
  try {
    current = storage.getItem("EmployeeSessionToken");
    expiresAt = storage.getItem("EmployeeSessionExpiresAt");
  } catch {
    return null;
  }
  if (!sent || !current || sent === current) return null;
  if (expiresAt && new Date(expiresAt) <= new Date()) return null;
  return {
    ...config,
    __employeeSessionRetried: true,
    headers: { ...(config.headers || {}), [HEADER]: current },
  };
}
